module.exports = __webpack_public_path__ + "img/io.f64864b6.svg";